export const TEMPLATE_STATES = {
	DRAFT: 'draft',
	PUBLISHED: 'published'
};

export const STATE_LABELS = {
	[TEMPLATE_STATES.DRAFT]: 'Draft',
	[TEMPLATE_STATES.PUBLISHED]: 'Published'
};
